export default __webpack_public_path__ + "assets/images/banner-forge.4fa0abe7.png";